import { render, staticRenderFns } from "./UserCardReports.vue?vue&type=template&id=763aaa46&scoped=true"
import script from "./UserCardReports.vue?vue&type=script&lang=js"
export * from "./UserCardReports.vue?vue&type=script&lang=js"
import style0 from "./UserCardReports.vue?vue&type=style&index=0&id=763aaa46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763aaa46",
  null
  
)

export default component.exports